import * as React from "react";
import { useDispatch } from "react-redux";
import { Typography, Stack, Icon, Button, Paper } from "@mui/material";
import { format as DateFormat } from "date-fns";
import PropTypes from "prop-types";
import SwiperCard from "../../components/SwipperCard";
import { Cancelar } from "../../redux/actions/dias";

const Solicitudes = (props) => {
  const { listado, params, color } = props;
  const dispatch = useDispatch();

  return (
    <>
      {listado &&
        listado.map((s) => (
          <SwiperCard
            card={
              <Paper
                sx={{
                  p: 1,
                  backgroundColor:
                    s.Estado === 0
                      ? color.main
                      : s.Estado === 1
                        ? "lightgreen"
                        : s.Estado === 2
                          ? "#e37a7c"
                          : color.selected,
                  border:
                    "1px solid " +
                    (s.Estado === 1
                      ? "lightgreen"
                      : s.Estado === 2
                        ? "#e37a7c"
                        : color.sText),
                }}
              >
                <Stack direction="row">
                  <Icon
                    sx={{
                      ml: 0.5,
                      mr: 2,
                      color:
                        s.Estado === 1 || s.Estado === 2
                          ? color.sText2
                          : color.sText,
                    }}
                    fontSize="large"
                  >
                    {s.Estado === 1
                      ? "event_available"
                      : s.Estado === 2 || s.Estado === 3
                        ? "event_busy"
                        : "event_note"}
                  </Icon>

                  <Stack sx={{ flexGrow: 1 }}>
                    <Stack direction="row">
                      <Typography
                        variant="caption"
                        sx={{
                          color:
                            s.Estado === 1 || s.Estado === 2
                              ? color.pText2
                              : color.pText,
                          flexGrow: 1,
                        }}
                      >
                        {DateFormat(new Date(s.Desde), "dd/MM/yyyy HH:00")}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color:
                            s.Estado === 1 || s.Estado === 2
                              ? color.sText2
                              : color.sText,
                        }}
                      >
                        {s.Cantidad + " día" + (s.Cantidad > 1 ? "s" : "")}
                      </Typography>
                    </Stack>
                    <Typography
                      variant="caption"
                      sx={{
                        lineBreak: "nowrap",
                        color:
                          s.Estado === 1 || s.Estado === 2
                            ? color.pText2
                            : color.pText,
                      }}
                    >
                      {s.Estado === 0
                        ? "En revisión"
                        : s.Estado === 1
                          ? "Otorgado"
                          : s.Estado === 2
                            ? "Rechazado"
                            : "Cancelada"}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        lineBreak: "normal",
                        fontStyle: "italic",
                        color:
                          s.Estado === 1 || s.Estado === 2
                            ? color.sText2
                            : color.sText,
                      }}
                    >
                      {s.Motivo}
                    </Typography>
                  </Stack>
                </Stack>
              </Paper>
            }
            wrapperStart={null}
            wrapperEnd={
              (s.Estado === 0 && (
                <Stack
                  height="100%"
                  sx={{
                    backgroundColor: "indianred",
                  }}
                >
                  <Button
                    sx={{
                      backgroundColor: "indianred",
                      height: "100%",
                    }}
                    variant="contained"
                    size="small"
                    onClick={() =>
                      dispatch(
                        Cancelar({
                          Conductor: params.conductor,
                          Dia: s.Id,
                          Token: params.token,
                        }),
                      )
                    }
                  >
                    Cancelar
                  </Button>
                </Stack>
              )) ||
              null
            }
          />
        ))}
    </>
  );
};
Solicitudes.propTypes = {
  listado: PropTypes.array,
  params: PropTypes.object,
  color: PropTypes.object,
};
export default Solicitudes;
